module.exports = __webpack_public_path__ + "images/08-05@2x_5f5a36cf.png";